import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getApplicationsReport: builder.query({
      query: (params) => ({
        url: "report/application/",
        params,
      }),
    }),
    getProductsReport: builder.query({
      query: (params) => ({
        url: "report/product/",
        params,
      }),
    }),
  }),
});

export const {
  useGetApplicationsReportQuery,
  useGetProductsReportQuery
} = reportApi;